export const SITE_TITLE = "Hustle N' Code";

export function formatPageTitle(pageTitle?: string): string {
  return pageTitle ? `${pageTitle} | ${SITE_TITLE}` : SITE_TITLE;
}
